/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsetcover3Inputs */

const en_placewebsetcover3 = /** @type {(inputs: Placewebsetcover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as cover`)
};

const de_placewebsetcover3 = /** @type {(inputs: Placewebsetcover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Titelbild`)
};

/**
* | output |
* | --- |
* | "Use as cover" |
*
* @param {Placewebsetcover3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsetcover3 = /** @type {((inputs?: Placewebsetcover3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsetcover3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsetcover3(inputs)
	return de_placewebsetcover3(inputs)
});
export { placewebsetcover3 as "placeWebSetCover" }